import { API_BASE_URL, API_ENDPOINTS } from '../config/api';
import type { ApiResponse, CostStatsResponse } from '../types/api';

class CostService {
  private getAuthHeader(): HeadersInit {
    const token = localStorage.getItem('access_token');
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  }

  /**
   * Get comprehensive monthly cost tracking across all AI providers
   * @returns Monthly cost statistics including limits, provider breakdown, and usage
   */
  async getCostStats(): Promise<CostStatsResponse> {
    const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.COST_STATS}`, {
      method: 'GET',
      headers: this.getAuthHeader(),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ message: 'Failed to fetch cost statistics' }));
      throw new Error(error.message || 'Failed to fetch cost statistics');
    }

    const result: ApiResponse<CostStatsResponse> = await response.json();

    if (!result.success || !result.data) {
      throw new Error(result.error || 'Failed to fetch cost statistics');
    }

    return result.data;
  }
}

export const costService = new CostService();
